module.exports = __webpack_public_path__ + "static/media/walletconnectLogo.a581b1e3.svg";